import React, { useContext } from "react";
import { DealerDetailsContext } from "../DealerDetailsView";
import ContentData from "../../../../constants/contentFile.json";
import { Col, Container, Row } from "react-bootstrap";
import EditIcon from "../../../../assets/images/editIcon.png";
import DeleteIcon from "../../../../assets/images/deleteIcon.png";
import NextIcon from "../../../../assets/images/next-icon.svg";
import SelectItem from "../../../../components/ThemeSelectOption/SelectOption";
import AlertBox from "../../../../components/AlertComponent/AlertBox";
import Loader from "../../../../components/Loader/Loader";
import DeletePopupImage from "../../../../assets/images/delete.svg";
import "./dealerDetails.css";
import PopupAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import PopupAlert from "../../../../components/PopupAlertSuccess/PopupAlert";
import ToggleArrow from "../../../../assets/images/Toggle-arrow.svg";

const DealerDetails = () => {
  const {
    goToDealerList,
    permissionAccess,
    spinnerStatus,
    statuses,
    handleStatusChange,
    editProduct,
    deleteDealer,
    deleteAlert,
    setDeleteAlert,
    dealerDetails,
    errorPopup,
    errorPopupMessage,
    setErrorPopup,
    dealerToLogin,
    buttonText,
    dealerDetailsApi,
    statusValue,
    successPopupMessage,
    successPopup,
    setSuccessPopup,
    dealerTableList,
    selectedStatus,
  } = useContext(DealerDetailsContext);
  return (
    <div className="pageBg dealerDetails">
      <div className="breadCrums">
        <span className="breadCrumsPointing" onClick={goToDealerList}>
          {ContentData.DealerPage.pageTitle}
        </span>
        <img className="nextIcon " src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.DealerPage.dealerDetail}
        </span>
      </div>
      <Container>
        {spinnerStatus && <Loader />}
        <div className="flexPage">
          <div className="headFlexing">
            <button type="button" onClick={goToDealerList} class="navbar-btn">
              <img src={ToggleArrow} alt="toggle-arrow" />
            </button>
            <div className="pageTittles">{dealerDetails.customerName}</div>
            <div className="subFlexing">
              <div
                className={`status-selector ${
                  permissionAccess?.delete ? "" : "disabledIconOnly"
                }`}
              >
                <SelectItem
                  selectPlaceholder="Status"
                  values={statuses}
                  selectNum="_id"
                  label="name"
                  defaultValue={selectedStatus}
                  handleSelectData={handleStatusChange}
                />
              </div>
              {/* edit */}
              <div
                className={`deletEditSection ${
                  permissionAccess?.edit ? "" : "disabledIconOnly"
                }`}
                onClick={editProduct}
              >
                <img src={EditIcon} alt="edit" />
              </div>
              <div
                className={`deletEditSection ${
                  permissionAccess?.delete ? "" : "disabledIconOnly"
                }`}
                onClick={() => setDeleteAlert(true)}
              >
                <img src={DeleteIcon} alt="delete" />
              </div>
            </div>
          </div>
        </div>
        <div className="basicContainer">
          <div className="viewDetailSection">
            {/* customer code */}
            <Row>
              <Col xl="4" lg="4" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.DealerPage?.customerCode}</h4>
                    <h5>
                      {dealerDetails?.customerCode
                        ? dealerDetails?.customerCode
                        : "-"}
                    </h5>
                  </div>
                </div>
              </Col>
              {/* customer name */}
              <Col xl="4" lg="4" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.DealerPage?.customerName}</h4>
                    <h5>
                      {dealerDetails?.customerName
                        ? dealerDetails?.customerName
                        : "-"}
                    </h5>
                  </div>
                </div>
              </Col>
              {/*contact no*/}
              <Col xl="4" lg="4" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.DealerPage?.contactNo}</h4>
                    <h5>
                      {dealerDetails?.mobile ? dealerDetails?.mobile : "-"}
                    </h5>
                  </div>
                </div>
              </Col>
              {/*district*/}
              <Col xl="4" lg="4" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.DealerPage?.district}</h4>
                    <h5>
                      {dealerDetails?.district ? dealerDetails?.district : "-"}
                    </h5>
                  </div>
                </div>
              </Col>
              {/*city*/}
              <Col xl="4" lg="4" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.DealerPage?.city}</h4>
                    <h5>{dealerDetails?.city ? dealerDetails?.city : "-"}</h5>
                  </div>
                </div>
              </Col>
              {/*postal code*/}
              <Col xl="4" lg="4" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.DealerPage?.postalCode}</h4>
                    <h5>
                      {dealerDetails?.postalCode
                        ? dealerDetails?.postalCode
                        : "-"}
                    </h5>
                  </div>
                </div>
              </Col>
              {/*region*/}
              <Col xl="4" lg="4" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.DealerPage?.region}</h4>
                    <h5>
                      {dealerDetails?.region ? dealerDetails?.region : "-"}
                    </h5>
                  </div>
                </div>
              </Col>
              {/*address*/}
              <Col xl="4" lg="4" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.DealerPage?.address}</h4>
                    <h5>
                      {dealerDetails?.streetOrHouseNumber
                        ? dealerDetails?.streetOrHouseNumber
                        : "-"}
                    </h5>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
      {/* delete detail */}
      <AlertBox
        alertMessage={ContentData.DealerPage.deleteSure}
        buttonSubmitText={ContentData.DealerPage.deleteText}
        popImage={DeletePopupImage}
        show={deleteAlert}
        setShow={setDeleteAlert}
        handleSubmitData={() => deleteDealer(dealerDetails?._id)}
        handleCancelClick={() => setDeleteAlert(false)}
      />
      <PopupAlertError
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            dealerToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            dealerDetailsApi(dealerDetails?._id);
          }
        }}
        errorAlertOnly={statusValue === 400 ? true : false}
      />
      {/* success popup */}
      <PopupAlert
        show={successPopup}
        alertMessage={successPopupMessage}
        handleSubmit={() => {
          setSuccessPopup(false);
          dealerTableList();
        }}
      />
    </div>
  );
};

export default DealerDetails;
